const MAX_EDGE_HOVER_ZONE_PX = 288;
const EDGE_HOVER_ZONE_RATIO = 0.15;

export const getCarouselHoverEdge = ({ clientX, left, right }) => {
  const width = right - left;
  const edgeHoverZone = Math.min(
    MAX_EDGE_HOVER_ZONE_PX,
    width * EDGE_HOVER_ZONE_RATIO,
  );

  if (clientX <= left + edgeHoverZone) {
    return 'left';
  }

  if (clientX >= right - edgeHoverZone) {
    return 'right';
  }

  return null;
};
